export const toKey = (orderNumber: number) => {
  switch (orderNumber) {
    case 1:
      return "first";
    case 2:
      return "second";
    case 3:
      return "third";
    case 4:
      return "fourth";
    case 5:
      return "fifth";
    case 6:
      return "sixth";
    case 7:
      return "seventh";
    case 8:
      return "eight";
    default:
      return "";
  }
};

export const findSocialMediaType = (name: string): number | null => {
  switch (name.toLowerCase()) {
    case "facebook":
      return 0;
    case "instagram":
      return 1;
    case "youtube":
      return 2;
    case "linkedin":
      return 3;
    case "tiktok":
      return 4;
    case "booking.com":
      return 5;
    case "other":
      return 6;
    default:
      return null;
  }
};
